"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchEventMap = exports.FetchTypeMap = exports.FetchResponseEvent = exports.FetchRequestEvent = exports.RequestMethod = void 0;
const eventBus_1 = require("../../eventBus");
var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["PATCH"] = "PATCH";
    RequestMethod["DELETE"] = "DELETE";
})(RequestMethod || (exports.RequestMethod = RequestMethod = {}));
class FetchRequestEvent extends eventBus_1.EventConfigurable {
}
exports.FetchRequestEvent = FetchRequestEvent;
class FetchResponseEvent extends eventBus_1.EventConfigurable {
}
exports.FetchResponseEvent = FetchResponseEvent;
var FetchTypeMap;
(function (FetchTypeMap) {
    FetchTypeMap["FETCH"] = "FETCH";
    FetchTypeMap["FETCH_RESPONSE"] = "FETCH_RESPONSE";
})(FetchTypeMap || (exports.FetchTypeMap = FetchTypeMap = {}));
exports.FetchEventMap = {
    [FetchTypeMap.FETCH]: FetchRequestEvent,
    [FetchTypeMap.FETCH_RESPONSE]: FetchResponseEvent,
};
//# sourceMappingURL=types.js.map